import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import Button from "../componentLibrary/Button";
import { useGetLegalDates } from "../api/queries";
import EULAContent from "./legal/EULAContent";

interface EULAModalProps {
  open: boolean;
  onClose: () => void;
}

const EULAModal: React.FC<EULAModalProps> = ({ open, onClose }) => {
  const { data: legalDates } = useGetLegalDates();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { maxHeight: "80vh" },
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="h2" className="font-bold">
          End User License Agreement
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Last updated:{" "}
          {legalDates?.eulaLastUpdated
            ? new Date(legalDates.eulaLastUpdated).toLocaleDateString()
            : "Loading..."}
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <EULAContent showLastUpdated={false} />
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EULAModal;
